import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const PatchObjectsButtonWidget: WidgetRegistryEntry = {
  name: "PatchObjectsButton",
  component: () =>
    import("./patch-objects-button-widget.component").then((module) => module.PatchObjectsButtonWidgetComponent),
  configuration: () => import("./configuration").then((module) => module.PatchObjectsButtonWidgetConfiguration)
};
